import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import {
  Button,
  DropDownButton,
  DropDownButtonItem,
} from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  deleteVesselsExportLoading,
  getAllVesselsExportLoading,
} from "./services/vesselsExportLoading.services";
import {
  clearFilterCustomVEL,
  clearVesselsExportLoadingGUID,
  setFilterCustomVEL,
  setVesselsExportLoadingGUID,
} from "./vesselsExportLoadingSlice";
// import { checkAcessRights } from "../../_helper/helper";
// import {
//   DELETE_ACCESS,
//   EDIT_ACCESS,
//   INSERT_ACCESS,
// } from "../../_contstants/common";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import _debounce from "lodash/debounce";
import { TextBox } from "@progress/kendo-react-inputs";
import {
  editToolsIcon,
  filterClearIcon,
  plusCircleIcon,
} from "@progress/kendo-svg-icons";
import { Tooltip } from "@progress/kendo-react-tooltip";
const VesselsExportLoading: React.FC = () => {
  const navigate = useNavigate();
  console.log(navigate);

  // const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  // const handleCreate = () => {
  //   navigate("/vesselsexportloading/create");
  // };

  const handleItemClick = (event: any) => {
    const clickedItem = event?.item?.text;
    if (clickedItem === "Shipping Movements") {
      navigate("/shippingmovements/create");
    } else if (clickedItem === "Container Import Discharge") {
      navigate("/containerimportdischarge/create");
    } else if (clickedItem === "Vessels Export Loading") {
      navigate("/vesselsexportloading/create");
    }
  };

  return (
    <>
      <DeleteVesselsExportLoadingDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Vessel's Export Loading List
          </Typography.h4>
          {/* {isAddAccess && ( */}
          <Tooltip anchorElement="target" position="top" parentTitle={true}>
            <DropDownButton
              className="sales-printing-opt-btn"
              text="Add New"
              title="Edit"
              themeColor={"primary"}
              onItemClick={handleItemClick}
              popupSettings={{
                anchorAlign: { horizontal: "right", vertical: "bottom" },
                popupAlign: { horizontal: "center", vertical: "top" },
                popupClass: "custom-popup-width",
              }}
            >
              <DropDownButtonItem
                svgIcon={plusCircleIcon}
                text="Shipping Movements"
              />
              <DropDownButtonItem
                text="Container Import Discharge"
                svgIcon={plusCircleIcon}
              />
              <DropDownButtonItem
                svgIcon={plusCircleIcon}
                text="Vessels Export Loading"
              />
            </DropDownButton>
          </Tooltip>
          {/* <Button
            onClick={handleCreate}
            fillMode={"solid"}
            themeColor={"primary"}
          >
            {"Add New"}
          </Button> */}
          {/* )} */}
        </GridLayoutItem>
        <GridLayoutItem>
          <VesselsExportLoadingGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const VesselsExportLoadingGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const isEditBtnRef = useRef<any>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  // const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const VesselsExportLoadingList = useAppSelector(
    (state) => state.vesselsExportLoading.VesselsExportLoadingList
  );
  const loading = useAppSelector((state) => state.vesselsExportLoading.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomVEL: any = useAppSelector(
    (state) => state.vesselsExportLoading.FilterCustomVEL
  );

  useEffect(() => {
    return () => {
      dispatch(setCurrentPage(0));
      if (!isEditBtnRef.current) {
        dispatch(clearFilterCustomVEL());
      }
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterCustomVEL,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllVesselsExportLoading(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEdit = (vessels_export_guid: number) => {
      navigate("/vesselsexportloading/edit", {
        state: { vessels_export_guid: vessels_export_guid },
      });
    };
    const handleOpenDeleteDialog = (vessels_export_guid: string) => {
      dispatch(openDialog("deleteVesselsExportLoading"));
      dispatch(setVesselsExportLoadingGUID(vessels_export_guid));
    };

    const handleItemClick = (event: any) => {
      const clickedItem = event?.item?.text;
      console.log(clickedItem);
      // if (clickedItem === "Sales Invoice") {
      //   handleSalesPrint(props.dataItem?.sale_guid);
      // } else if (clickedItem === "Gate Pass") {
      //   handleGatePassPrint(props.dataItem?.sale_guid);
      // } else if (clickedItem === "Envelope") {
      //   handleEnvelopePrint(props.dataItem?.sale_guid);
      // }
    };
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          ref={isEditBtnRef}
          onClick={() => {
            isEditBtnRef.current = true;
            handleEdit(props.dataItem?.vessels_export_guid);
          }}
        >
          <FiEdit className="absolute-position" style={{ fontSize: "20px" }} />
        </IconButton>

        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <DropDownButton
            className="sales-printing-opt-btn"
            svgIcon={editToolsIcon}
            fillMode={"flat"}
            title="Edit"
            themeColor={"primary"}
            onItemClick={handleItemClick}
            popupSettings={{
              anchorAlign: { horizontal: "right", vertical: "bottom" },
              popupAlign: { horizontal: "center", vertical: "top" },
            }}
          >
            <DropDownButtonItem text="Shipping Movements" />
            <DropDownButtonItem text="Container Import Discharge" />
            <DropDownButtonItem text="Vessels Export Loading" />
          </DropDownButton>
        </Tooltip>
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          onClick={() =>
            handleOpenDeleteDialog(props.dataItem?.vessels_export_guid)
          }
        >
          <MdDelete
            className="absolute-position"
            style={{ fontSize: "24px" }}
          />
        </IconButton>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  // if (loading) return <LoadingPanel gridRef={gridRef} />;
  const handleEditCell = (vessels_export_guid: number) => {
    navigate("/vesselsexportloading/edit", {
      state: { vessels_export_guid: vessels_export_guid },
    });
  };
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={
          filter
            ? filterBy(VesselsExportLoadingList, filter)
            : VesselsExportLoadingList
        }
        onFilterChange={handleFilterChange}
        total={
          VesselsExportLoadingList[0]?.item_count ||
          VesselsExportLoadingList.length
        }
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="at_jetty"
          title="AT Jetty"
          width={120}
          cell={(props: any) => (
            <td
              className="hoverableName"
              onClick={() => {
                isEditBtnRef.current = true;
                handleEditCell(props.dataItem?.vessels_export_guid);
              }}
            >
              {props.dataItem?.at_jetty}
            </td>
          )}
        />
        <Column field="eta" title="ETA" />
        <Column field="etd" title="ETD" />
        <Column
          field="vessels_name"
          title="Vessel's Name"
          filterable
          filterCell={CommonFilterCell}
        />
        <Column field="agent_name" title="Agents" />
        <Column field="cargo" title="Cargo" />
        <Column field="port_name" title="Next Port" />
        {/* {(isEditAccess || isDeleteAccess) && ( */}
        <Column
          field="id"
          title="Actions"
          cell={MyEditCommandCell}
          width={"140px"}
          filterable={false}
        />
        {/* )} */}
      </KendoGrid>
    </>
  );
};

const DeleteVesselsExportLoadingDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const VesselsExportLoadingGUID = useAppSelector(
    (state) => state.vesselsExportLoading.VesselsExportLoadingGUID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const handleDeleteAction = async (ID: string) => {
    if (ID) {
      const response = await dispatch(deleteVesselsExportLoading(ID));
      const payload = {
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllVesselsExportLoading(payload));
        dispatch(closeDialog());
        dispatch(clearVesselsExportLoadingGUID());
      } else {
        dispatch(getAllVesselsExportLoading(payload));
        dispatch(closeDialog());
        dispatch(clearVesselsExportLoadingGUID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteVesselsExportLoading" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Vessel's Export Loading"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Vessel's Export Loading?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(VesselsExportLoadingGUID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const CommonFilterCell = (props: any) => {
  const dispatch = useAppDispatch();
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomVEL: any = useAppSelector(
    (state) => state.vesselsExportLoading.FilterCustomVEL
  );
  const isFilterRef = useRef(true);
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputField, setInputField] = useState(props.field || "");

  const onChange = (event: any) => {
    setInputValue(event.target.value);
    setInputField(event.target.name);
  };

  const delayedApiCall = React.useCallback(
    _debounce((updatedFilters: any) => {
      dispatch(setCurrentPage(0));
      const payload = {
        ...updatedFilters,
        limit: +pageLimit,
        skip: 0 * +pageLimit,
      };

      dispatch(getAllVesselsExportLoading(payload));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (!isFilterRef.current) {
      const updatedFilters = { ...FilterCustomVEL, [inputField]: inputValue };
      dispatch(setFilterCustomVEL(updatedFilters));
      delayedApiCall(updatedFilters);
    } else {
      isFilterRef.current = false;
    }
    return () => {
      delayedApiCall.cancel();
    };
  }, [inputValue, delayedApiCall]);

  const onClearButtonClick = (event: any) => {
    event.preventDefault();
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: event,
    });

    const updatedFilters = { ...FilterCustomVEL, [props.field]: "" };
    dispatch(setFilterCustomVEL(updatedFilters));

    const payload = {
      ...updatedFilters,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };

    dispatch(getAllVesselsExportLoading(payload));
  };
  return (
    <div className="d-flex">
      <TextBox
        value={FilterCustomVEL[props.field] || ""}
        name={props.field || ""}
        onChange={onChange}
      />
      <Button
        svgIcon={filterClearIcon}
        title="Clear"
        disabled={!FilterCustomVEL[props.field]}
        onClick={onClearButtonClick}
        type="button"
        style={{
          marginLeft: "8px",
        }}
      ></Button>
    </div>
  );
};

export default VesselsExportLoading;
